"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateTelephone = exports.FormatTelephone = void 0;
function FormatTelephone(telephone) {
    return telephone.replace(" ", "").replace("-", "").replace("(", "").replace(")", "");
}
exports.FormatTelephone = FormatTelephone;
function ValidateTelephone(telephone) {
    if (typeof telephone !== "string")
        return false;
    telephone = telephone.trim();
    return new RegExp(/^(\+{1}[0-9]{1,3}|)[0-9]{9}$/).test(FormatTelephone(telephone));
}
exports.ValidateTelephone = ValidateTelephone;
//# sourceMappingURL=ValidationTelephone.js.map